"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var diff_match_patch_1 = require("diff-match-patch");
function isElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
exports.isElement = isElement;
function isText(node) {
    return node.nodeType === node.TEXT_NODE;
}
exports.isText = isText;
function isDocument(node) {
    return node.nodeType === node.DOCUMENT_NODE;
}
exports.isDocument = isDocument;
function isDocumentFragment(node) {
    return node.nodeType === node.DOCUMENT_FRAGMENT_NODE;
}
exports.isDocumentFragment = isDocumentFragment;
function isComment(node) {
    return node.nodeType === node.COMMENT_NODE;
}
exports.isComment = isComment;
function strictEqual(item1, item2) {
    return item1 === item2;
}
exports.strictEqual = strictEqual;
function areArraysEqual(array1, array2, comparator) {
    if (comparator === void 0) { comparator = strictEqual; }
    if (array1.length !== array2.length) {
        return false;
    }
    for (var i = 0, l = array1.length; i < l; ++i) {
        if (!comparator(array1[i], array2[i])) {
            return false;
        }
    }
    return true;
}
exports.areArraysEqual = areArraysEqual;
function getAttributeNames(element) {
    if (element.getAttributeNames) {
        return element.getAttributeNames();
    }
    else {
        var attributes = element.attributes;
        var length_1 = attributes.length;
        var attributeNames = new Array(length_1);
        for (var i = 0; i < length_1; i++) {
            attributeNames[i] = attributes[i].name;
        }
        return attributeNames;
    }
}
function stripNewlines(nodes) {
    return Array.from(nodes).filter(function (node) {
        return (node.nodeName !== '#text' ||
            (node.textContent && node.textContent.trim() !== ''));
    });
}
/**
 * Compares DOM nodes for equality.
 * @param node1 The first node to compare.
 * @param node2 The second node to compare.
 * @param deep If true, the child nodes are compared recursively too.
 * @returns `true`, if the 2 nodes are equal, otherwise `false`.
 */
function areNodesEqual(node1, node2, deep) {
    if (deep === void 0) { deep = false; }
    if (node1 === node2) {
        return true;
    }
    if (node1.nodeType !== node2.nodeType ||
        node1.nodeName !== node2.nodeName) {
        return false;
    }
    if (isText(node1) || isComment(node1)) {
        if (node1.data !== node2.data) {
            return false;
        }
    }
    else if (isElement(node1)) {
        var attributeNames1 = getAttributeNames(node1).sort();
        var attributeNames2 = getAttributeNames(node2).sort();
        if (!areArraysEqual(attributeNames1, attributeNames2)) {
            return false;
        }
        for (var i = 0, l = attributeNames1.length; i < l; ++i) {
            var name_1 = attributeNames1[i];
            var value1 = node1.getAttribute(name_1);
            var value2 = node2.getAttribute(name_1);
            if (value1 !== value2) {
                return false;
            }
        }
    }
    if (deep) {
        var childNodes1 = node1.childNodes;
        var childNodes2 = node2.childNodes;
        if (childNodes1.length !== childNodes2.length) {
            return false;
        }
        for (var i = 0, l = childNodes1.length; i < l; ++i) {
            if (!areNodesEqual(childNodes1[i], childNodes2[i], deep)) {
                return false;
            }
        }
    }
    return true;
}
exports.areNodesEqual = areNodesEqual;
/**
 * Gets a list of `node`'s ancestor nodes up until and including `rootNode`.
 * @param node Node whose ancestors to get.
 * @param rootNode The root node.
 */
function getAncestors(node, rootNode) {
    if (rootNode === void 0) { rootNode = null; }
    if (!node || node === rootNode) {
        return [];
    }
    var ancestors = [];
    var currentNode = node.parentNode;
    while (currentNode) {
        ancestors.push(currentNode);
        if (currentNode === rootNode) {
            break;
        }
        currentNode = currentNode.parentNode;
    }
    return ancestors;
}
exports.getAncestors = getAncestors;
function never(message) {
    if (message === void 0) { message = 'visual-dom-diff: Should never happen'; }
    throw new Error(message);
}
exports.never = never;
// Source: https://stackoverflow.com/a/7616484/706807 (simplified)
function hashCode(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        // tslint:disable-next-line:no-bitwise
        hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
    }
    return hash;
}
exports.hashCode = hashCode;
/**
 * Returns a single character which should replace the given node name
 * when serializing a non-text node.
 */
function charForNodeName(nodeName) {
    return String.fromCharCode(0xe000 + (hashCode(nodeName) % (0xf900 - 0xe000)));
}
exports.charForNodeName = charForNodeName;
/**
 * Moves trailing HTML tag markers in the DIFF_INSERT and DIFF_DELETE diff items to the front,
 * if possible, in order to improve quality of the DOM diff.
 */
function cleanUpNodeMarkers(diff) {
    for (var i = 0; i < diff.length - 2;) {
        var diff0 = diff[i];
        var diff1 = diff[i + 1];
        var diff2 = diff[i + 2];
        if (diff0[0] !== diff_match_patch_1.DIFF_EQUAL ||
            diff1[0] === diff_match_patch_1.DIFF_EQUAL ||
            diff2[0] !== diff_match_patch_1.DIFF_EQUAL) {
            i++;
            continue;
        }
        var string0 = diff0[1];
        var string1 = diff1[1];
        var string2 = diff2[1];
        var lastChar0 = string0[string0.length - 1];
        var lastChar1 = string1[string1.length - 1];
        if (lastChar0 !== lastChar1 ||
            lastChar0 < '\uE000' ||
            lastChar0 >= '\uF900') {
            i++;
            continue;
        }
        diff0[1] = string0.substring(0, string0.length - 1);
        diff1[1] = lastChar0 + string1.substring(0, string1.length - 1);
        diff2[1] = lastChar0 + string2;
        if (diff0[1].length === 0) {
            diff.splice(i, 1);
        }
    }
}
exports.cleanUpNodeMarkers = cleanUpNodeMarkers;
var dmp = new diff_match_patch_1.diff_match_patch();
/**
 * Diffs the 2 strings and cleans up the result before returning it.
 */
function diffText(oldText, newText) {
    var diff = dmp.diff_main(oldText, newText);
    var result = [];
    var temp = [];
    cleanUpNodeMarkers(diff);
    // Execute `dmp.diff_cleanupSemantic` excluding equal node markers.
    for (var i = 0, l = diff.length; i < l; ++i) {
        var item = diff[i];
        if (item[0] === diff_match_patch_1.DIFF_EQUAL) {
            var text = item[1];
            var totalLength = text.length;
            var prefixLength = /^[^\uE000-\uF8FF]*/.exec(text)[0].length;
            if (prefixLength < totalLength) {
                var suffixLength = /[^\uE000-\uF8FF]*$/.exec(text)[0].length;
                if (prefixLength > 0) {
                    temp.push([diff_match_patch_1.DIFF_EQUAL, text.substring(0, prefixLength)]);
                }
                dmp.diff_cleanupSemantic(temp);
                pushAll(result, temp);
                temp.length = 0;
                result.push([
                    diff_match_patch_1.DIFF_EQUAL,
                    text.substring(prefixLength, totalLength - suffixLength),
                ]);
                if (suffixLength > 0) {
                    temp.push([
                        diff_match_patch_1.DIFF_EQUAL,
                        text.substring(totalLength - suffixLength),
                    ]);
                }
            }
            else {
                temp.push(item);
            }
        }
        else {
            temp.push(item);
        }
    }
    dmp.diff_cleanupSemantic(temp);
    pushAll(result, temp);
    temp.length = 0;
    dmp.diff_cleanupMerge(result);
    cleanUpNodeMarkers(result);
    return result;
}
exports.diffText = diffText;
function pushAll(array, items) {
    var destination = array.length;
    var source = 0;
    var length = items.length;
    while (source < length) {
        array[destination++] = items[source++];
    }
}
function markUpNode(node, elementName, className) {
    var document = node.ownerDocument;
    var parentNode = node.parentNode;
    var previousSibling = node.previousSibling;
    if (isElement(node)) {
        node.classList.add(className);
    }
    else if (previousSibling &&
        previousSibling.nodeName === elementName &&
        previousSibling.classList.contains(className)) {
        previousSibling.appendChild(node);
    }
    else {
        var wrapper = document.createElement(elementName);
        wrapper.classList.add(className);
        parentNode.insertBefore(wrapper, node);
        wrapper.appendChild(node);
    }
}
exports.markUpNode = markUpNode;
function isTableValid(table, verifyColumns) {
    var columnCount;
    return validateTable(table);
    function validateTable(_a) {
        var childNodes = _a.childNodes;
        var filteredChildNodes = stripNewlines(childNodes);
        var l = filteredChildNodes.length;
        var i = 0;
        if (i < l && filteredChildNodes[i].nodeName === 'CAPTION') {
            i++;
        }
        if (i < l && filteredChildNodes[i].nodeName === 'THEAD') {
            if (!validateRowGroup(filteredChildNodes[i])) {
                return false;
            }
            i++;
        }
        if (i < l && filteredChildNodes[i].nodeName === 'TBODY') {
            if (!validateRowGroup(filteredChildNodes[i])) {
                return false;
            }
            i++;
        }
        else {
            return false;
        }
        if (i < l && filteredChildNodes[i].nodeName === 'TFOOT') {
            if (!validateRowGroup(filteredChildNodes[i])) {
                return false;
            }
            i++;
        }
        return i === l;
    }
    function validateRowGroup(_a) {
        var childNodes = _a.childNodes, nodeName = _a.nodeName;
        var filteredChildNodes = stripNewlines(childNodes);
        if (nodeName === 'TBODY' && filteredChildNodes.length === 0) {
            return false;
        }
        for (var i = 0, l = filteredChildNodes.length; i < l; ++i) {
            if (!validateRow(filteredChildNodes[i])) {
                return false;
            }
        }
        return true;
    }
    function validateRow(_a) {
        var childNodes = _a.childNodes, nodeName = _a.nodeName;
        var filteredChildNodes = stripNewlines(childNodes);
        if (nodeName !== 'TR' || filteredChildNodes.length === 0) {
            return false;
        }
        if (verifyColumns) {
            if (columnCount === undefined) {
                columnCount = filteredChildNodes.length;
            }
            else if (columnCount !== filteredChildNodes.length) {
                return false;
            }
        }
        for (var i = 0, l = filteredChildNodes.length; i < l; ++i) {
            if (!validateCell(filteredChildNodes[i])) {
                return false;
            }
        }
        return true;
    }
    function validateCell(node) {
        var nodeName = node.nodeName;
        if (nodeName !== 'TD' && nodeName !== 'TH') {
            return false;
        }
        var cell = node;
        var colspan = cell.getAttribute('colspan');
        var rowspan = cell.getAttribute('rowspan');
        return ((colspan === null || colspan === '1') &&
            (rowspan === null || rowspan === '1'));
    }
}
exports.isTableValid = isTableValid;
